// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ActiveStorageBlob from "./active-storage-blob.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "url": {
      "column": null,
      "name": "url",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ActiveStorage::Attachment",
  "collectionKey": "active_storage/attachments",
  "collectionName": "active_storage_attachments",
  "i18nKey": "active_storage/attachment",
  "camelizedLower": "activeStorage::Attachment",
  "name": "ActiveStorageAttachment",
  "nameDasherized": "active-storage-attachment",
  "pluralName": "active_storage_attachments",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "blob",
      "macro": "belongs_to",
      "resource_name": "ActiveStorageBlob",
      "through": null
    },
    {
      "className": "Record",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "record",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "blob_id",
      "column": {
        "default": null,
        "name": "blob_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_blob_id",
      "column": {
        "default": null,
        "name": "old_blob_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_record_id",
      "column": {
        "default": null,
        "name": "old_record_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "record_id",
      "column": {
        "default": null,
        "name": "record_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "record_type",
      "column": {
        "default": null,
        "name": "record_type",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "blob",
      "macro": "belongs_to",
      "resource_name": "ActiveStorageBlob",
      "through": null
    }
  ],
  "paramKey": "attachment",
  "primaryKey": "id"
}

/** Frontend model for ActiveStorageAttachment. */
export default class ActiveStorageAttachment extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  url() {
    return this.readAttributeUnderscore("url")
  }

  /** @returns {boolean} */
  hasUrl() {
    const value = this.url()

    return this._isPresent(value)
  }

  /** @returns {import("./active-storage-blob.js").default | null} */
  blob() {
    return this._readBelongsToReflection({modelClass: ActiveStorageBlob, reflectionName: "blob"})
  }

  /** @returns {Promise<import("./active-storage-blob.js").default | null>} */
  loadBlob() {
    if (!("blobId" in this)) throw new Error("Foreign key method wasn't defined: blobId")

    const id = this.blobId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "blob",
        model: this,
        modelClass: ActiveStorageBlob
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./active-storage-blob.js").default | null>} */
  ensureBlobLoaded() {
    return this.ensureAssociationLoaded("blob")
  }
}
